import { render, staticRenderFns } from "./omset.vue?vue&type=template&id=7c65c4d6"
import script from "./omset.vue?vue&type=script&lang=js"
export * from "./omset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports